import { render, staticRenderFns } from "./TagsFilterNew.vue?vue&type=template&id=66e0e11a&scoped=true"
import script from "./TagsFilterNew.vue?vue&type=script&lang=js"
export * from "./TagsFilterNew.vue?vue&type=script&lang=js"
import style0 from "./TagsFilterNew.vue?vue&type=style&index=0&id=66e0e11a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66e0e11a",
  null
  
)

export default component.exports